export enum FieldRole {
  DIMENSION = 'DIMENSION',
  MEASURE = 'MEASURE',
  TIMESTAMP = 'TIMESTAMP',
}
